type PersonaFormFieldValues = {
  name?: string;
  highlights?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention -- matches persona API field name
  avatar_url?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention -- matches persona API field name
  is_default?: boolean;
};

type HasPersonaFormChangesParams = {
  values: PersonaFormFieldValues;
  initialValues: PersonaFormFieldValues;
  edit: boolean;
};

const hasPersonaFormChanges = ({ values, initialValues, edit }: HasPersonaFormChangesParams) => {
  const normalizedInitialName = initialValues.name ?? "";
  const normalizedInitialHighlights = initialValues.highlights ?? "";
  const normalizedInitialAvatarUrl = initialValues.avatar_url ?? "";
  const isInitialDefaultChecked = initialValues.is_default ?? false;

  const normalizedName = values.name ?? "";
  const normalizedHighlights = values.highlights ?? "";
  const normalizedAvatarUrl = values.avatar_url ?? "";
  const isCurrentDefaultChecked = values.is_default ?? false;

  const hasCoreFieldChanges =
    normalizedName !== normalizedInitialName ||
    normalizedHighlights !== normalizedInitialHighlights ||
    normalizedAvatarUrl !== normalizedInitialAvatarUrl;

  if (edit) {
    return hasCoreFieldChanges;
  }

  return hasCoreFieldChanges || isCurrentDefaultChecked !== isInitialDefaultChecked;
};

export default hasPersonaFormChanges;
